// src/lang/index.js
import pt from './translations/pt.json';
import en from './translations/en.json';
export default {
    pt,
    en
};